





























import { defineComponent, ref, toRefs } from '@vue/composition-api';
import { snackbar } from '@/components/GlobalSnackbar';
import { resetUserPasswordMenu } from '../state';
import { useClient } from '@/use';
import UserPassword from '@/components/UserPassword.vue';

export default defineComponent({
  name: 'ResetUserPasswordMenu',
  components: { UserPassword },
  props: {
    username: {
      type: String,
      required: true,
    },
  },
  setup(props) {
    const client = useClient();
    const { username } = toRefs(props);
    const formValid = ref(false);
    const password = ref('');

    function closeMenu() {
      resetUserPasswordMenu.value = false;
    }

    const updatePW = (val: string) => {
      password.value = val;
    };

    async function resetUserPassword() {
      if (!password.value) {
        return;
      }

      const payload = {
        username: username.value,
        password: password.value,
      };

      await client.resetUserPassword(payload);
      closeMenu();
      snackbar.dispatch({ text: 'Password Successfully Reset' });
    }

    return {
      formValid,
      closeMenu,
      resetUserPassword,
      UserPassword,
      updatePW,
    };
  },
});
